/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  Fee,
  UtxFeeFindParams,
  UtxFeeCalcFeeForUserParams
} from './schema'



export const utxFeeFind = (
    params: UtxFeeFindParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Fee[]>> => {
    return axios.get(
      `/fee`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxFeeFindQueryKey = (params: UtxFeeFindParams,) => [`/fee`, ...(params ? [params]: [])];

    
export type UtxFeeFindQueryResult = NonNullable<Awaited<ReturnType<typeof utxFeeFind>>>
export type UtxFeeFindQueryError = AxiosError<void>

export const useUtxFeeFind = <TData = Awaited<ReturnType<typeof utxFeeFind>>, TError = AxiosError<void>>(
 params: UtxFeeFindParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxFeeFind>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxFeeFindQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxFeeFind>>> = ({ signal }) => utxFeeFind(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxFeeFind>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxFeeCalcFeeForUser = (
    params: UtxFeeCalcFeeForUserParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.get(
      `/fee/calc-fee`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxFeeCalcFeeForUserQueryKey = (params: UtxFeeCalcFeeForUserParams,) => [`/fee/calc-fee`, ...(params ? [params]: [])];

    
export type UtxFeeCalcFeeForUserQueryResult = NonNullable<Awaited<ReturnType<typeof utxFeeCalcFeeForUser>>>
export type UtxFeeCalcFeeForUserQueryError = AxiosError<unknown>

export const useUtxFeeCalcFeeForUser = <TData = Awaited<ReturnType<typeof utxFeeCalcFeeForUser>>, TError = AxiosError<unknown>>(
 params: UtxFeeCalcFeeForUserParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxFeeCalcFeeForUser>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxFeeCalcFeeForUserQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxFeeCalcFeeForUser>>> = ({ signal }) => utxFeeCalcFeeForUser(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxFeeCalcFeeForUser>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

